module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Barcode-af6816693f0be5b6d6fc5847f96748f7.svg";